import classnames from 'classnames';
import { BEMBlock } from '@helpers/classnames';
import './BannerCard.scss';

function BannerCard({ banner, className }) {
    const [block, BEMElement] = BEMBlock('banner-card');

    return (
        <div className={classnames(block, className)}>
            <div
                className={BEMElement('image-wrapper')}
                dangerouslySetInnerHTML={{ __html: banner }} // eslint-disable-line react/no-danger
            />
        </div>
    );
}

export default BannerCard;
